import { render, staticRenderFns } from "./FlightBook.vue?vue&type=template&id=baf30aba&"
import script from "./FlightBook.vue?vue&type=script&lang=js&"
export * from "./FlightBook.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports